// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3DhVC","requiredAsterisk":"Info_requiredAsterisk__1385P"};